import React, { FC, Fragment } from 'react';
import { Box, Text, Checkbox } from '@bechtel/gds';
import { FieldProps } from 'formik';
import { ListSelectionStyled, DrawerSubHeaderStyled } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';

export const SupportingForeman: FC<FieldProps> = ({ form }) => {
  return (
    <Fragment>
      <DrawerSubHeaderStyled>
        <Box alignItems={{ sm: 'center' }}>
          <Box ml={{ sm: '400' }}>
            <Trans>Include Supporting Foremen</Trans>
          </Box>
        </Box>
      </DrawerSubHeaderStyled>
      <ListSelectionStyled
        data-testid="supporting-foreman"
        onClick={() => {
          form.setFieldValue('isSupportingForeman', !form.values.isSupportingForeman);
        }}
      >
        <Box mr={{ sm: '500' }}>
          <Checkbox checked={form.values.isSupportingForeman === true} readOnly />
        </Box>
        <Text color="bechtel.colors.grey.1000" size="400">
          <Trans>Yes</Trans>
        </Text>
      </ListSelectionStyled>
    </Fragment>
  );
};
